// extracted by mini-css-extract-plugin
export default {"sidebyside":"styles_sidebyside__5gmlO"};